function formatUser(history) {
  const { metadata } = history;
  const username = history.user__username || "";
  const email = history.user__email || "";

  if (metadata && metadata.user_email) {
    const suffix1 = metadata.device_id || metadata.device_name ? ", Device:" : "";
    const suffix2 = metadata.device_name ? ` ${metadata.device_name}` : "";
    const suffix3 = metadata.device_id ? ` (#${metadata.device_id})` : "";
    return `App User: ${metadata.user_email}${suffix1}${suffix2}${suffix3}`;
  }

  if (username && email && username !== email) {
    return `${username}/${email}`;
  }
  if (username) {
    return username;
  }
  if (email) {
    return email;
  }
  return "";
}

export default formatUser;
